import { GtmTracker } from '@/modules/common/services/analytics';
import { Categories } from '@/types/models/Analytics';

const trackEvent = GtmTracker.trackerWithDefaultProps({
  category: Categories.Trade
});

const trackAmplitudeEvent = GtmTracker.trackerWithDefaultProps({
  page_screen: 'deposit',
  digital_experience: 'investor',
  experience_section: 'broker'
});

export function trackTradeTransactionViewLoad() {
  trackAmplitudeEvent({
    event_type: 'load',
    event_name: 'view'
  });
}

export function trackDepositClick(value = 0) {
  trackAmplitudeEvent({
    event_type: 'click',
    page_screen_section: 'body',
    event_name: 'confirm_deposit',
    question_answer: value
  });
}

export const trackInputFeedback = ({
  isValueSmallerThanMinimum = false,
  value = 0
} = {}) => {
  const labelSuffix = isValueSmallerThanMinimum
    ? 'Valor menor que 1 real'
    : 'Saldo insuficiente';

  trackEvent({
    action: 'Clique Realizar Investimento',
    label: `${Categories.Trade} - ${labelSuffix}`,
    value
  });
};

export const trackNoMoneyWarning = () =>
  trackEvent({
    action: 'Clique Realizar Investimento',
    label: `${Categories.Trade} - Sem saldo`
  });

export const trackInvestmentSuccess = (value = 0) =>
  trackEvent({
    action: 'Clique Realizar Investimento',
    label: `${Categories.Trade} - Sucesso`,
    value
  });

export const trackInvestmentSuggestion = (suggestionLabel: string) => {
  trackEvent({
    action: 'Clique Valor Pre Definido',
    label: suggestionLabel
  });
  trackAmplitudeEvent({
    event_type: 'click',
    page_screen_section: 'deposit_value',
    event_name: 'select_answer',
    event_target: suggestionLabel
  });
};
